import React from 'react';
import { List, Map } from 'immutable';
import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form';
import { SelectBinder } from '@pearlchain/component-lib-ui';

import { RequestId } from '../../utils/requests';
import { dataToOptionsByKey } from '../../utils/binder/binderHelpers';
import { RequestIdFetcher } from '@pearlchain/component-lib-common';

interface Props {
    input: WrappedFieldInputProps;
    meta: WrappedFieldMetaProps;
    dependsOn?: {};
    disabled: boolean;
}

export default function ForecastROPSchemeBinder(props: Props) {
    return <RequestIdFetcher
        requestId={RequestId.LIST_FORECASTROP_SCHEMES}
        render={(opts: any) => {
            let aux = opts;
            if(opts){
                const map = Map().set('externalReference','')
                aux = opts.insert(0,map)
            }
            
        return (
            <SelectBinder options={dataToOptionsByKey(aux as List<Map<string,any>>|undefined, 'externalReference')} { ...props }/>
            )
        }}
        />
}
